export default "__VITE_ASSET__DyNfnV81__"